<p-chart 
type="bar" 
[data]="data" 
[options]="options" 
[height]="'100%'"
[width]="'100%'"></p-chart>
